import { apiFetch } from './client';

export interface PointsLedgerRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  caller_id: string;
  delta: number;
  reason: string;
  source_kind: string | null;
  source_id: string | null;
  created_at: string;
}

export interface PointsSummary {
  balance: number;
  lifetime_earned: number;
  lifetime_spent: number;
  event_count: number;
}

export interface AdjustPointsBody {
  delta: number;
  reason: string;
  source_kind?: 'admin' | 'redeem' | 'correction';
  source_id?: string | null;
}

export const points = {
  getSummary: (callerProfileId: string) =>
    apiFetch<PointsSummary>(`/api/caller-profiles/${callerProfileId}/points`),
  listLedger: (callerProfileId: string, p: { limit?: number; before?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.limit) q.set('limit', String(p.limit));
    if (p.before) q.set('before', p.before);
    return apiFetch<{ rows: PointsLedgerRow[] }>(
      `/api/caller-profiles/${callerProfileId}/points/ledger?${q}`,
    );
  },
  adjust: (callerProfileId: string, body: AdjustPointsBody) =>
    apiFetch<PointsLedgerRow>(
      `/api/caller-profiles/${callerProfileId}/points/adjust`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
};
